import styled from 'styled-components';
import { CONTRAST, HALF_CONTRAST } from '../../../theme';

export const Header = styled.h3`
  margin: 0 0 8px 0;
  font-weight: 500;
  font-size: 18px;
  color: ${CONTRAST};
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
`;
export const Subheader = styled.h4`
  margin: 0 0 8px 0;
  font-weight: 500;
  font-size: 16px;
  color: ${CONTRAST};
`;
export const Paragraph = styled.p`
  margin: 0 0 12px 0;
  font-size: 14px;
  color: ${HALF_CONTRAST};
`;
